<button
    class="primary-line-switcher"
    ds-button
    kind="primary"
    variant="filled"
    size="large"
    [disabled]="buttonState.isDisabled"
    (click)="onButtonClick()">
    {{ buttonState.title }}
</button>
